import QueueFactory from './queue'

const middlewareFactory = (Queue) => function middleware(storeAPI) {
    return function wrapDispatch(next) {
        return function handleAction(action) {
            // Do anything here: pass the action onwards with next(action),
            // or restart the pipeline with storeAPI.dispatch(action)
            // Can also use storeAPI.getState() here

            const nextAction = next(action)

            try {
                Queue.handleAction(action, storeAPI)
            } catch (error) {
                /* eslint-disable-next-line no-console */
                console.error(error)
            }

            return nextAction
        }
    }
}

function initialize({
    reducerName,
} = {}) {
    const Queue = QueueFactory({
        reducerName,
    })
    const middleware = middlewareFactory(Queue)

    return {
        middleware,

        reducer: Queue.reducer,
        reducerName: Queue.reducerName,

        create: Queue.creators.create,
        insert: Queue.creators.insert,
        remove: Queue.creators.remove,

        items: Queue.selectors.items,
        length: Queue.selectors.length,
        getFirst: Queue.selectors.getFirst,
    }
}

export default initialize
